import React from "react";
import type { BlockProps } from "./blocks/registry";
import { Heading } from "../design-system/atoms/Heading";
import Icon from "../design-system/atoms/Icon";

const ConnectorArrow = ({ className = "" }: { className?: string }) => (
  <Icon
    src={`https://site-lms.fra1.digitaloceanspaces.com/arrow_93a6fa25d2.svg`}
    alt=""
    className={`h-16 w-28 drop-shadow-sm ${className}`}
  />
);
type StrapiMedia = {
  url?: string;
};

type EtapeItem = {
  id?: number | string;
  titre?: string;
  descr?: string;
  iconAlt?: string;
  icon?: StrapiMedia;
};

type EtapesData = {
  id?: number | string;
  documentId?: string;
  __component?: string;
  titre?: string;
  soutitre?: string;
  etapes?: EtapeItem[];
  [key: string]: unknown;
};
export default function Etapes({ data }: BlockProps<EtapesData>) {
  if (!data) return null;
  const etapes = Array.isArray(data.etapes) ? data.etapes : [];
  return (
    <section
      key={data.id}
      className="bg-muted py-12 px-6 md:px-12 flex flex-col items-center"
    >
      <div className="lms-container">
        <header className="text-center space-y-2">
          <p className="text-xl font-playfair font-medium text-[#8CCB1C]">
            {data.soutitre}
          </p>
          <Heading as="h2" className="text-4xl lg:text-[44px] font-bold text-text">
            {data.titre}
          </Heading>
        </header>

        {/* --- CONTENEUR DES ÉTAPES --- */}
        <div className="relative mx-auto mt-10 grid w-full max-w-[1200px] grid-cols-1 gap-6 md:mt-12 xl:grid-cols-3 xl:gap-8">
           {etapes.map((step, index) => {
            const isLast = index === etapes.length - 1;

            return (
              <div
                key={step.titre}
            className="relative mx-auto flex w-full max-w-[380px] flex-col items-center xl:max-w-none"
              >
                <article className="relative z-10 rounded-[32px] bg-secondary px-8 pt-8 pb-12 text-center text-white shadow-[0_20px_45px_RGBA(226,27,68,0.25)]">

                  {/* Cercle vert */}
                  <div className="absolute left-1/2 top-0 flex h-28 w-48 -translate-x-1/2 items-end justify-center">
                    <div className="flex h-28 w-48 items-center justify-center rounded-b-full bg-primaryGreen">
                      <span className="text-3xl font-semibold text-white">
                        {index + 1}
                      </span>
                    </div>
                  </div>

                  <div className="mt-6 flex flex-col items-center gap-3">
                    <Icon
                      src={step.icon?.url || "/fallback-icon.svg"}
                      alt={step.iconAlt ?? step.titre ?? ""}
                      size={96}
                      className="h-24 w-24 object-contain z-20"
                    />

                    <h3 className="text-2xl font-semibold">
                      {step.titre}
                    </h3>

                    <p className="text-lg leading-relaxed text-white/90">
                      {step.descr}
                    </p>
                  </div>
                </article>

                {/* Flèche mobile + tablette */}
                {!isLast && (
                  <div className="flex xl:hidden mt-1 mb-1 z-10">
                    <ConnectorArrow className="rotate-90 mx-auto" />
                  </div>
                )}

                {/* Flèche desktop */}
                {!isLast && (
                  <div className="hidden xl:flex absolute top-1/2 -right-14 -translate-y-1/2 z-50">
                    <ConnectorArrow />
                  </div>
                )}
              </div>
            );
          })}
        </div>

      </div>
    </section>
  );
}
